/**
 * Copy for Android WebAPK launch failures where the system dialog says the app
 * "requires Chrome" even though Chrome is already installed.
 *
 * This is a Chrome/Android platform bug (common after Chrome auto-updates on
 * Samsung devices). Our JS never runs while that dialog is up — recovery has to
 * happen from a normal Chrome tab or by restarting the device.
 *
 * @see https://stackoverflow.com/questions/78514015/instead-of-running-my-pwa-says-it-requires-chrome
 */

export const ANDROID_PWA_REQUIRES_CHROME_FAQ = {
  question: 'Android home-screen app says it requires Chrome?',
  answer:
    'That dialog is a known Android/Chrome glitch after Chrome updates — Chrome can already be installed. Restart the phone first (usually fixes it). If it still fails: open Chrome once, then retry the icon. On Samsung, set Settings → Apps → Chrome → Battery to Unrestricted. Last resort: uninstall Riftbound DB, open www.riftbound-db.com in Chrome, and Install app again from the browser menu.',
} as const;

export const ANDROID_PWA_REPAIR_STEPS = [
  'Restart your phone — this usually restores the home-screen app after a Chrome update.',
  'Open the Chrome app once, then tap the Riftbound DB icon again.',
  'On Samsung: Settings → Apps → Chrome → Battery → Unrestricted (Restricted battery mode can block WebAPK launches).',
  'Still broken? Uninstall Riftbound DB, open www.riftbound-db.com in Chrome, then use Install app / Add to Home screen again.',
] as const;

export const ANDROID_PWA_REPAIR_TITLE = 'Home-screen app won’t open?';

export const ANDROID_PWA_REPAIR_SUMMARY =
  'Android sometimes shows “requires Chrome” for an installed Riftbound DB shortcut even when Chrome is already installed. Try these steps:';
